import React from "react";

import { CircularProgress } from "@mui/material";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Checkbox from "@src/sharedComponents/Checkbox/Checkbox";
import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./Card.module.css";

interface Props {
  title: React.ReactNode;
  titleRight?: React.ReactNode;
  subTitle?: React.ReactNode;
  heading: React.ReactNode;
  headingSubtitle?: React.ReactNode;
  text: React.ReactNode;
  checkboxLabel?: React.ReactNode;
  isChecked?: boolean;
  onCheckboxChange?: (isChecked: boolean) => void;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  isMutating?: boolean;
  checkboxIsDisabled?: boolean;
  checkboxTooltipText?: string;
}

const Card: React.FC<Props> = ({
  checkboxLabel,
  className,
  heading,
  headingSubtitle,
  isChecked,
  onCheckboxChange,
  onClick,
  subTitle,
  text,
  title,
  titleRight,
  isMutating,
  checkboxIsDisabled,
  checkboxTooltipText,
}) => {
  const animationClass =
    onClick === undefined ? styles.noCursor : styles.animate;
  return (
    <div
      onClick={onClick}
      className={toClassName(styles.container, className, animationClass)}
    >
      {onClick !== undefined && <div className={styles.highlight} />}
      <div className={styles.body}>
        <div className={styles.top}>
          <div className={styles.topLeft}>
            {title}

            {subTitle}
          </div>

          {titleRight}
        </div>

        <div className={styles.bottom}>
          <div className={styles.flexColumn}>
            {heading}
            {headingSubtitle}
          </div>

          {text}
        </div>
      </div>

      {checkboxLabel &&
        isChecked !== undefined &&
        onCheckboxChange !== undefined && (
          <div
            className={styles.checkboxContainer}
            onClick={(e) => e.stopPropagation()}
          >
            {isMutating ? (
              <div className={styles.flex}>
                <div className={styles.loader}>
                  <CircularProgress color={"inherit"} size={20} />
                </div>

                <Text variant={"body"} color={"text"}>
                  {checkboxLabel}
                </Text>
              </div>
            ) : (
              <Tooltip tooltipText={checkboxTooltipText} placement={"top"}>
                <div>
                  <Checkbox
                    checked={isChecked}
                    onChange={onCheckboxChange}
                    label={checkboxLabel}
                    disabled={checkboxIsDisabled}
                  />
                </div>
              </Tooltip>
            )}
          </div>
        )}
    </div>
  );
};

export default Card;
